export enum AvatarSize {
  SMALL = 'small',
  MEDIUM = 'medium',
  LARGE= 'large'
}
